import React from 'react';

type ClassNameConsumerProps = {
  className?: string;
  children: (className?: string) => React.ReactElement;
};

export const ClassNameConsumer: ({
  className,
  children,
}: ClassNameConsumerProps) => React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>> = ({
  className,
  children,
}: ClassNameConsumerProps) => children(className);
